import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { EditableFault, FaultState } from '../shared/editable-fault/editable-fault';
import { WeblinkFault } from '../shared/weblink-fault/weblink-fault';
import { Status } from '../../core/status/status';
import { FaultFieldMapping } from '../shared/fault-field-mapping/fault-field-mapping';
import { WeblinkFaultService } from '../shared/weblink-fault.service';
import { SafeUrl } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
import { FormatPipe } from '../shared/format.pipe';
import { TileLayout } from '../shared/tile-layout/tile-layout';
import {WeblinkSettings} from "@docma-weblink/shared/weblink-data/weblink-data";

@Component({
  selector: 'app-weblink-fault-tile',
  templateUrl: './weblink-fault-tile.component.html',
  styleUrls: ['./weblink-fault-tile.component.scss']
})
export class WeblinkFaultTileComponent implements OnInit {

  @Output() checkChanged: EventEmitter<any> = new EventEmitter();
  @Output() editFault: EventEmitter<{fault: EditableFault, settings: WeblinkSettings}> = new EventEmitter();

  @Input() fault: EditableFault;
  @Input() settings?: WeblinkSettings;
  @Input() status: Status[];
  @Input() fields: FaultFieldMapping[];
  @Input() layout: TileLayout;

  @Input() search = 'Mangel';
  header: string = '';
  hideDetails = true;

  public FaultState = FaultState;

  constructor(private faultService: WeblinkFaultService) { }

  ngOnInit() {
    // if(this.layout.hasImage && !this.fault.attachmentUrl) {
    //   const attachmentID = this.fault.Data.find((obj) => obj.Key === 'LastImage').Val;
    //   //load image
    //   this.faultService.getWeblinkAttachment(attachmentID).subscribe( url => {
    //     this.fault.attachmentUrl = url;
    //   } );
    // }

    if(this.layout.captionProperties.length===1){
      this.header = this.getFormattedValueForProperty(this.layout.captionProperties[0].FieldId);
    } else if (this.layout.captionProperties.length>=2) {
      this.header =
        `#${this.getFormattedValueForProperty(
          this.layout.captionProperties[0].FieldId)} ${this.getFormattedValueForProperty(this.layout.captionProperties[1].FieldId)}`;
    } else {
      this.header = 'no fields!';
    }
  }

  getFormattedValueForProperty(key: string): string {
    return FormatPipe.transform(this.getValueForProperty(key));
  }

  getValueForProperty(key: string): string {
    return this.fault.Data.find( data => data.Key === key).Val;
  }

  changeCheck() {
    if (!this.fault.newStatus && this.fault.IsEditable) {
    this.fault.isSelected = !this.fault.isSelected;
    this.checkChanged.emit(this);
    } else {
      this.fault.isSelected = false;
    }
  }

  edit() {
    this.editFault.emit({fault: this.fault, settings: this.settings});
  }

  dateToLocalDate(date: string): string {
    return new Date(Date.parse(date)).toLocaleDateString();
  }

  toggleDetails() {
    this.hideDetails = !this.hideDetails;
  }
}
